import clsx from 'clsx';
import { Component, Image as ImageType } from '@headless-workspace/typings';
import { CardDirection, CardSize } from '../../newComposables';
import { PropsWithAriaLabel, PropsWithClassName, PropsWithDataLayer } from '../../props';
import { GlowTile } from '../card';

export type BrandoramaProps = PropsWithDataLayer & {
    id?: string;
    brandName: string;
    image: ImageType;
    href: string;
};

type GlowBrandoramaBannerProps = PropsWithClassName & PropsWithAriaLabel & BrandoramaProps;

/**
 * Component called Cards/Brand on FIGMA
 * A component that renders Brandorama component.
 * @param brandName - The name of Brandorama.
 * @param image - The url & alternative text of brandorama image.
 * @param href - The url of the brand page.
 * @param ariaLabel - The aria-label of the brandorama.
 * @param className - Additional styles for the container.
 * @param dataLayer - The data layer component.
 */

export const GlowBrandoramaBanner: Component<GlowBrandoramaBannerProps> = ({
    brandName,
    image,
    href,
    ariaLabel,
    className,
    dataLayer,
}) => {
    return (
        <li className={clsx('list-none inline-flex', className)}>
            <GlowTile
                size={CardSize.S}
                direction={CardDirection.Col}
                classNames={{
                    width: 'w-[16.25rem]',
                    height: 'h-[13.125rem]',
                }}
                ariaLabel={ariaLabel}
                href={href}
                dataLayer={dataLayer}
                content={{
                    title: {
                        text: brandName,
                        className: 'text-center',
                    },
                    classNames: {
                        height: 'h-full',
                    },
                }}
                image={{
                    src: image,
                    classNames: {
                        image: 'aspect-16/9',
                        cta: 'items-start',
                    },
                    loading: 'lazy',
                }}
            />
        </li>
    );
};
